<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-10 15:27:00
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 18:33:32
-->
<template>
  <div class="myplanBox1">
    <el-tabs tab-position="left"  v-model="activeName"  style="height: 200px;" @tab-click="handleClick">
      <el-tab-pane label="个人信息" name="second">
        <personal v-if="personshow"></personal>
      </el-tab-pane>
      <el-tab-pane label="我的课程" name="first">
        <plan v-if="planshow"></plan>
      </el-tab-pane>
      <!-- <el-tab-pane label="考试历史" name="third">
        <examHistory v-if="examshow" ref="examHistoryRef"></examHistory>
      </el-tab-pane> -->
      <el-tab-pane label="我的考试" name="fourth">
        <myExam v-if="myExamshow" ref="myExamRef"></myExam>
      </el-tab-pane>
      <el-tab-pane label="我的消息" name="fifth">
        <notice v-if="noticeshow" ref="notice"></notice>
      </el-tab-pane>
      <el-tab-pane label="我的证书" name="six">
        <mycertificate v-if="mycertificateshow" ref="mycertificate"></mycertificate>
      </el-tab-pane>
      <el-tab-pane label="平台反馈" name="seven">
        <feedback v-if="feedbackshow" ref="feedback"></feedback>
      </el-tab-pane>
      <!-- <el-tab-pane label="个人会员缴费" name="eight">
        <memberPay v-if="membershow" ref="memberPay"></memberPay>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="个人缴费记录" name="nine">
        <paymentRecord v-if="paymentshow" ref="paymentRecord"></paymentRecord>
      </el-tab-pane> -->
      <!-- <el-tab-pane v-if="$store.state.showBtn" label="报名考试" name="ten">
        <signup v-if="signupshow" ref="signup"></signup>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import plan from './plan'
import personal from './personal'
// import examHistory from './examHistory'
import notice from './notice'
import myExam from './myExam'
import mycertificate from './mycertificate'
import feedback from './feedback'
import memberPay from './memberPay'
// import paymentRecord from './paymentRecord'
// import signup from './signUp'
export default {
  name: 'myplan',
  data () {
    return {
      activeName: 'second',
      planshow: false,
      personshow: false,
      examshow: false,
      noticeshow: false,
      myExamshow: false,
      mycertificateshow: false,
      feedbackshow: false,
      membershow: false,
      paymentshow: false,
      signupshow: false
    }
  },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/myplan') {
          this.$store.dispatch('setNavIndex', '-2')
          if (Object.keys(to.query).length === 0) {
            this.activeName = 'second'
          } else {
            this.activeName = to.query.activeName
          }
          this.handleClick()
        }
      },
      immediate: true
    }
  },
  components: {
    plan,
    personal,
    // examHistory,
    notice,
    myExam,
    mycertificate,
    feedback,
    // eslint-disable-next-line vue/no-unused-components
    memberPay
    // paymentRecord,
    // signup
  },
  methods: {
    // 切换tab
    handleClick () {
      if (this.activeName === 'first') {
        this.planshow = true
      } else if (this.activeName === 'second') {
        this.personshow = true
      } else if (this.activeName === 'third') {
        this.examshow = true
        this.$nextTick(() => {
          this.$refs['examHistoryRef'].init()
        })
      } else if (this.activeName === 'fourth') {
        this.myExamshow = true
        this.$nextTick(() => {
          this.$refs['myExamRef'].init()
        })
      } else if (this.activeName === 'fifth') {
        this.noticeshow = true
        this.$nextTick(() => {
          this.$refs['notice'].init()
        })
      } else if (this.activeName === 'six') {
        this.mycertificateshow = true
      } else if (this.activeName === 'seven') {
        this.feedbackshow = true
      } else if (this.activeName === 'eight') {
        this.membershow = true
      } else if (this.activeName === 'nine') {
        this.paymentshow = true
        this.$nextTick(() => {
          this.$refs['paymentRecord'].init()
        })
      } else if (this.activeName === 'ten') {
        this.signupshow = true
        this.$nextTick(() => {
          this.$refs['signup'].init()
        })
      }
    }
  }
}
</script>
<style  scoped>
  .myplanBox1{
    width:1200px;
    min-height: 80vh;
    margin:20px auto;
  }
  .myplanBox1 /deep/ .el-tabs--left, .el-tabs--right{
    height:auto !important;
  }
  .myplanBox1 /deep/ .el-tabs--left .el-tabs__item.is-left{
    text-align: left;
    width: 210px;
  }

</style>
